import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/${args?.id}`,
      method: "get",
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
      cacheTTL: 300000,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: args?.params?.role === "customer" ? "users/customers" : "users",
      method: "get",
      params: args?.params,
      authorization: true,
      config: {
        showErr: true,
      },
      cacheTTL: 300000,
    };

    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url:
        args?.data?.role === "customer"
          ? `users/customers/${args?.id}`
          : `users/${args?.id}`,
      method: "patch",
      data: args?.data,
      authorization: true,
      config: {
        successMsg: "updated Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "update",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const verifyOperator = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/verify/${args?.id}`,
      method: "patch",
      data: args?.data,
      authorization: true,
      config: {
        successMsg: "Operator verification status updated successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "update",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const staffs = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/staffs`,
      method: "get",
      params: args?.params,
      authorization: true,
      config: {
        showErr: true,
      },
      cacheTTL: 300000,
    };

    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

const updateStatus = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/status/${args?.id}`,
      method: "patch",
      data: args?.data,
      authorization: true,
      config: {
        successMsg: "status updated Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "update",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getCustomerAnalytics = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/customers/${args?.id}/analytics`,
      method: "get",
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
      cacheTTL: 300000,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const loginAs = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/${args?.id}/login-as`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Redirecting to store panel...",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const changePassword = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/change-password`,
      method: "patch",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Password changed successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getReferrals = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/customers/${args?.id}/referrals`,
      method: "get",
      params: args?.params,
      authorization: true,
      config: {
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  find,
  list,
  update,
  verifyOperator,
  staffs,
  updateStatus,
  getCustomerAnalytics,
  getReferrals,
  loginAs,
  changePassword,
  createCustomer: async (args: ParamsProps) => {
    try {
      const config: ReturnType = {
        url: "users/customers",
        method: "post",
        authorization: true,
        data: args?.data,
        config: {
          successMsg: "Customer registered successfully",
          showErr: true,
        },
      };
      const response = await request(config);
      return response;
    } catch (err: any) {
      throw new Error(err);
    }
  },
  enableBiometrics: async (args: ParamsProps) => {
    try {
      const config: ReturnType = {
        url: "users/biometrics/enable",
        method: "post",
        data: args?.data,
        authorization: true,
        config: {
          showErr: true,
          successMsg: "Biometrics enabled successfully",
        },
      };
      const response = await request(config);
      return response;
    } catch (err: any) {
      throw new Error(err);
    }
  },
  loginWithBiometrics: async (args: ParamsProps) => {
    try {
      const config: ReturnType = {
        url: "users/biometrics/login",
        method: "post",
        data: args?.data,
        authorization: false,
        config: {
          showErr: true,
          successMsg: "Logged in successfully",
        },
      };
      const response = await request(config);
      return response;
    } catch (err: any) {
      throw new Error(err);
    }
  },
};
